import SvgIcon from "./svgIcon";
import React from "react";

function createSvgIcon(path, displayName) {
  let Icon = props => <SvgIcon {...props}>{path}</SvgIcon>;

  Icon.displayName = displayName;
  Icon = React.memo(Icon);

  return Icon;
}

export default createSvgIcon;
